/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input, OnChanges} from '@angular/core';
import * as _ from 'lodash';

import {TARGETING_IMPORTS} from '../targeting-imports';

@Component({
  imports: TARGETING_IMPORTS,
  selector: 'adn-targeting-day-parting-summary',
  template: '<span class="commaSeparated"><span *ngFor="let day of dayKeys" class="commaSeparate">{{ \'label.days.\' + day | translate }}<span *ngIf="data[day] !== 24"> ({{data[day]}} hours)</span></span></span>'
})
export class DayPartingSummaryComponent implements OnChanges {
  @Input() targets: any;

  data: Record<string, number> = {};
  dayKeys: string[] = [];

  private readonly days = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'];

  ngOnChanges(): void {
    const target = this.targets || {};
    this.data = {};
    _.forEach(this.days, (day) => {
      const theHours = _.filter(target, (entryObj) => _.indexOf(entryObj.daysOfWeek, day) > -1);
      const totalHours = _.flatten(_.map(theHours, 'hoursOfDay')).length;
      if (totalHours > 0) {
        this.data[day] = totalHours;
      }
    });
    this.dayKeys = Object.keys(this.data);
  }
}
